import { allArticles } from "@/mocks/articles";

const cardImages: string[] = [
  "https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20with%20open%20laptop%20displaying%20organized%20spreadsheet%20layout%2C%20warm%20cream%20background%2C%20soft%20afternoon%20light%2C%20neat%20workspace%20with%20ceramic%20coffee%20cup%2C%20clean%20Scandinavian%20aesthetic%2C%20professional%20editorial%20photography&width=600&height=400&seq=fg-card-img-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Two%20laptops%20displaying%20different%20data%20comparison%20charts%20side%20by%20side%20on%20warm%20wooden%20table%2C%20natural%20light%20from%20window%2C%20minimalist%20home%20office%2C%20Scandinavian%20interior%20design%2C%20soft%20beige%20walls%2C%20clean%20composition%2C%20professional%20atmosphere&width=600&height=400&seq=fg-card-img-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Step%20by%20step%20checklist%20notebook%20with%20handwritten%20instructions%20beside%20tablet%20showing%20spreadsheet%20template%2C%20warm%20desk%20lamp%20glow%2C%20small%20plant%20in%20concrete%20pot%2C%20organized%20learning%20setup%2C%20clean%20minimalist%20aesthetic%2C%20soft%20earth%20tones&width=600&height=400&seq=fg-card-img-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Real%20time%20order%20tracking%20dashboard%20on%20large%20monitor%20with%20colorful%20status%20bars%20and%20progress%20indicators%2C%20warm%20office%20environment%2C%20professional%20analytics%20setup%2C%20clean%20modern%20interface%2C%20soft%20natural%20lighting&width=600&height=400&seq=fg-card-img-04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cost%20comparison%20charts%20and%20savings%20calculator%20displayed%20on%20screen%20with%20printed%20invoice%20papers%20nearby%2C%20warm%20workspace%20lighting%2C%20professional%20financial%20analysis%20setting%2C%20clean%20Scandinavian%20desk%20style&width=600&height=400&seq=fg-card-img-05&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Performance%20scorecards%20with%20star%20ratings%20on%20tablet%20screen%20resting%20on%20warm%20beige%20surface%2C%20coffee%20nearby%2C%20soft%20morning%20sunlight%2C%20data%20driven%20decision%20concept%2C%20professional%20editorial%20style&width=600&height=400&seq=fg-card-img-06&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Open%20laptop%20showing%20shipping%20logistics%20dashboard%20with%20map%20overlay%20and%20route%20visualization%2C%20warm%20office%20lighting%2C%20professional%20analytics%20environment%2C%20clean%20modern%20design%2C%20soft%20neutral%20palette&width=600&height=400&seq=fg-card-img-07&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Blank%20spreadsheet%20template%20on%20laptop%20with%20notebook%20and%20pen%20showing%20setup%20instructions%2C%20fresh%20morning%20light%2C%20succulent%20plant%2C%20clean%20Scandinavian%20workspace%2C%20organized%20and%20inviting%20atmosphere&width=600&height=400&seq=fg-card-img-08&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Modern%20tablet%20displaying%20comparison%20analysis%20between%20different%20options%20with%20color%20coded%20charts%2C%20warm%20wooden%20desk%2C%20natural%20light%2C%20professional%20review%20concept%2C%20clean%20minimalist%20composition&width=600&height=400&seq=fg-card-img-09&orientation=landscape",
];

export default function FeatureGrid() {
  const featuredThree = allArticles.slice(0, 3);
  const remainingArticles = allArticles.slice(3);

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <p className="font-heading text-foreground-600 text-lg tracking-wider uppercase font-semibold">
              ACBuy<span className="font-light">Spreadsheet</span>
            </p>
            <h2 className="mt-2 text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              Featured Guides
            </h2>
          </div>
          <Link
            to="/acbuyspreadsheet-guide"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            View all guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-14">
          <Link
            to={`/guide/${featuredThree[0].slug}`}
            className="group bg-foreground-950 rounded-2xl p-6 md:p-8 flex flex-col justify-between min-h-[320px] relative overflow-hidden transition-all hover:scale-[1.02] cursor-pointer"
          >
            <div>
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/15 text-white text-sm font-bold mb-6">
                01
              </span>
              <h3 className="text-xl md:text-2xl font-bold text-white leading-snug">
                {featuredThree[0].title}
              </h3>
              <p className="mt-3 text-sm text-white/60">
                {featuredThree[0].metaDescription.slice(0, 140)}...
              </p>
            </div>
            <span className="inline-flex items-center gap-1.5 mt-6 text-sm font-medium text-white/80 group-hover:text-white transition-colors whitespace-nowrap">
              Read the guide
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>

          <Link
            to={`/guide/${featuredThree[1].slug}`}
            className="group bg-background-50 rounded-2xl p-0 flex flex-col justify-between min-h-[320px] relative overflow-hidden transition-all hover:scale-[1.02] border border-background-200/70 cursor-pointer"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src={cardImages[0]}
                alt={featuredThree[1].imageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <div className="p-6 md:p-8 flex-1 flex flex-col justify-between">
              <div>
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold mb-3">
                  <i className="ri-scales-line text-xs"></i>
                  {featuredThree[1].badge}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 leading-snug">
                  {featuredThree[1].title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {featuredThree[1].metaDescription.slice(0, 120)}...
                </p>
              </div>
              <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                Read more
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          <Link
            to={`/guide/${featuredThree[2].slug}`}
            className="group bg-background-50 rounded-2xl p-0 flex flex-col justify-between min-h-[320px] relative overflow-hidden transition-all hover:scale-[1.02] border border-background-200/70 cursor-pointer"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src={cardImages[1]}
                alt={featuredThree[2].imageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <div className="p-6 md:p-8 flex-1 flex flex-col justify-between">
              <div>
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-secondary-100 text-secondary-800 rounded-full text-xs font-semibold mb-3">
                  <i className="ri-funds-line text-xs"></i>
                  {featuredThree[2].badge}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 leading-snug">
                  {featuredThree[2].title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {featuredThree[2].metaDescription.slice(0, 120)}...
                </p>
              </div>
              <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                Read more
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        </div>

        {remainingArticles.length > 0 && (
          <>
            <div className="flex items-center gap-3 mb-8">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                More ACBuySpreadsheet Resources
              </h3>
              <div className="flex-1 h-px bg-background-200/70"></div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {remainingArticles.map((article, idx) => (
                <Link
                  key={article.slug}
                  to={`/guide/${article.slug}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all hover:scale-[1.02] cursor-pointer"
                >
                  <div className="h-[160px] overflow-hidden bg-background-100">
                    <img
                      src={cardImages[idx + 2]}
                      alt={article.imageAlt}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full text-[11px] font-semibold mb-2 whitespace-nowrap">
                      {article.badge}
                    </span>
                    <h4 className="text-sm md:text-base font-heading font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h4>
                    <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                      {article.metaDescription}
                    </p>
                    <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600 whitespace-nowrap">
                      Read article
                      <i className="ri-arrow-right-line text-[10px]"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}